import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Confirm, Dimmer, Loader, Modal } from 'semantic-ui-react';
import { PerkProgram } from '../Perks/PerkProgram';
import { AppContext } from '../../context/app/appContext';
import { getCurrentPageRoutePart } from "../../utilities/Utility";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useHistory, Switch, Route } from 'react-router-dom'

export const PerksProgramManagement = (props) => {

    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    let API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, });
    const history = useHistory();

    const dimmer = 'blurring';
    const [showSaveChangesModal, setShowSaveChangesModal] = useState(false);
    const [perkPrograms, setPerkPrograms] = useState([]);
    // const [allPerkProgramsSelection, setAllPerkProgramsSelection] = useState(false);
    const appContext = useContext(AppContext);

    const [newPerksProgramName, setNewPerksProgramName] = useState('');
    const currentDate = new Date();
    const [newPerksProgramStartDate, setNewPerksProgramStartDate] = useState(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); return temp;});
    const [newPerksProgramEndDate, setNewPerksProgramEndDate] = useState(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); temp.setDate(-15); temp.setMonth(temp.getMonth() + 2); temp.setDate(0); return temp; });
    const [showNewPerksProgramInlineForm, setShowNewPerksProgramInlineForm] = useState(false);

    const [endDateEnabled, setEndDateEnabled] = useState(false);
    const [invalidDateRange, setInvalidDateRange] = useState(false);
    const [monthlyEndDates, setMonthlyEndDates] = useState([]);
    const [monthlyStartDates, setMonthlyStartDates] = useState([]);

    const [currentlyEditingPerkProgramId, setCurrentlyEditingPerkProgramId] = useState('');
    const [idToDelete, setIdToDelete] = useState('');
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoModalText, setInfoModalText] = useState('');
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);

    const [activeProgramsSection, setActiveProgramsSection] = useState(false);

    // useEffect(() => {
    //     let startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    //     let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);;
    //     setNewPerksProgramStartDate(startDate);
    //     endDate.setMonth(endDate.getMonth() + 1)
    //     setNewPerksProgramEndDate(endDate.setDate(0))
    // }, [])

    useEffect(() => {
        setMonthlyEndDates(getMonthlyEndDates(newPerksProgramStartDate));
    }, [newPerksProgramStartDate])

    useEffect(() => {
        setMonthlyStartDates(getMonthlyStartDates(newPerksProgramStartDate));
    }, [])

    useEffect(() => {
        setPerkPrograms(appContext.perkPrograms);
        console.info(appContext.perkPrograms);
        // eslint-disable-next-line
    }, [appContext.perkPrograms]);

    useEffect(() => {
        (async function loadPerkPrograms() {
            await appContext.loadPerkPrograms();
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const programSection = getCurrentPageRoutePart();
        programSection === 'active' ? setActiveProgramsSection(true) : setActiveProgramsSection(false);
        // eslint-disable-next-line
    }, [getCurrentPageRoutePart()]); // TODO: could be performance issue?

    useEffect(() => {
        const invalidDateRange = endDateEnabled ? newPerksProgramEndDate <= newPerksProgramStartDate || newPerksProgramEndDate === currentDate : false;
        console.info({invalidDateRange});
        invalidDateRange ? setInvalidDateRange(true) : setInvalidDateRange(false);
        // eslint-disable-next-line
    }, [newPerksProgramStartDate, newPerksProgramEndDate]);

    const addNewProgramHandler = async (event) => {
        event.preventDefault();
        console.table(newPerksProgramName, newPerksProgramStartDate, newPerksProgramEndDate);
        var tempStartDate = newPerksProgramStartDate
        tempStartDate.setHours(newPerksProgramStartDate.getHours() - (newPerksProgramStartDate.getTimezoneOffset() / 60))
        var tempEndDate = newPerksProgramEndDate;
        tempEndDate.setHours(newPerksProgramEndDate.getHours() - (newPerksProgramEndDate.getTimezoneOffset() / 60))
        tempEndDate.setDate(newPerksProgramEndDate.getDate() + 1)

        console.table(newPerksProgramName, tempStartDate, tempEndDate);

        await appContext.addPerksProgram({
            name: newPerksProgramName,
            startDate: tempStartDate,
            endDate: tempEndDate,
            neverExpire: !endDateEnabled,
        });

        setNewPerksProgramName('');
        // let startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        // let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        // setNewPerksProgramStartDate(startDate);
        // endDate.setMonth(endDate.getMonth() + 1)
        // setNewPerksProgramEndDate(endDate.setDate(0))

        setNewPerksProgramStartDate(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); return temp;});
        setNewPerksProgramEndDate(() => {const temp = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); temp.setDate(-15); temp.setMonth(temp.getMonth() + 2); temp.setDate(0); return temp; });

        // setNewPerksProgramStartDate(new Date(monthlyStartDates[0]))
        // setNewPerksProgramEndDate(new Date(monthlyEndDates[0]))
        setShowNewPerksProgramInlineForm(false);
    };

    const editProgramHandler = (event) => {
        setShowSaveChangesModal(true);
    };

    const saveChangesModalCloseHandler = async () => {
        //         try{
        //             const slackProgramUpdate = await axios.post(
        //                 `https://stgapi.perkfix.com/slack/message`,
        //                 {
        //                     "email": "abelp915@gmail.com",
        //                     "message": `You have updated the ${newPerksProgramName} perk program.`
        //                 }
        //               );
        //             console.info({slackProgramUpdate})

        //         }
        //         catch(error){
        // console.info({error})
        //         }
        setShowSaveChangesModal(false);
    };

    const handlePerkProgramSelectionChange = (perkProgramId, selected) => {
        const selectedPerkPrograms = perkPrograms.map(perkProgram => {
            if (perkProgram.id === perkProgramId) return {
                ...perkProgram,
                selected: !selected,
            }; // TODO: should be toggle
            return perkProgram;
        });
        console.clear();
        console.table(selectedPerkPrograms);
        setPerkPrograms(selectedPerkPrograms);
    };

    const checkIfAlreadyEditing = (programId) => {
        console.info(`checkIfAlreadyEditing programId: ${programId}`);
        if (currentlyEditingPerkProgramId !== '' || showNewPerksProgramInlineForm) {
            setInfoModalText(`Please save or cancel current updates.`);
            setShowInfoModal(true);
            return true;
        } else {
            setCurrentlyEditingPerkProgramId(programId);
            return false;
        }
    }

    const handleResetEditInProgress = () => {
        setCurrentlyEditingPerkProgramId('');
    }

    const handleCancelDelete = (programId) => {
        console.info(`canceled program delete... ${programId}`);
        setShowConfirmDeleteModal(false);
    }

    const handleConfirmDelete = async () => {
        console.info(`confirmed program delete...`);
        setShowConfirmDeleteModal(false);
        appContext.setLoading();
        const response = await API.post(`/delete-perk-program`, { programId: idToDelete }).catch(error => {
            console.info({ error });
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                console.info(error.response.data.status);
                const { code, message } = error.response.data.status;
                console.info({ code });
                setInfoModalText(message);
                setShowInfoModal(true);
                appContext.setLoading(false);
                return error.response.data.status;
            } else {
                setInfoModalText(`There was an error. Please try again later.`);
                setShowInfoModal(true);
                appContext.setLoading(false);
            }
        });
        if (response && response.data && response.data.status) {
            const { code, message } = response.data.status;
            console.info({ code, message });
            setInfoModalText(message);
            setShowInfoModal(true);
            if (code === `perkProgram/deleted`) appContext.deletePerksProgram(idToDelete);
            appContext.setLoading(false);
        }
    }

    const handleDelete = (programId) => {
        setIdToDelete(programId);
        console.info(`Deleting Perk Program with ID: ${programId}`);
        setShowConfirmDeleteModal(true);
    }

    const newProgramCancelHandler = () => {
        var x = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        console.info({x})
        var y = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        y.setDate(-15);
        y.setMonth(y.getMonth() + 2);
        y.setDate(0);
        console.info({y})
        setNewPerksProgramStartDate(x)
        setNewPerksProgramEndDate(y);

        setNewPerksProgramName('');
        setShowNewPerksProgramInlineForm(false)
    }

    const getMonthlyEndDates = (date) => {
        let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const totalMonths = 12;
        startDate.setDate(0)
        startDate.setDate(startDate.getDate() + 15)
        startDate.setMonth(startDate.getMonth() + 1)
        let tempDate = startDate.setDate(0)
        const validEndDates = [tempDate];
        for (let i = 1; i <= totalMonths; i++) {
            startDate.setDate(startDate.getDate() + 15)
            startDate.setMonth(startDate.getMonth() + 1)
            let nextMonthDate = startDate.setDate(0)
            validEndDates.push(nextMonthDate);
        }
        return validEndDates;
    }

    const getMonthlyStartDates = (date) => {
        let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const totalMonths = 12;
        startDate.setDate(1)
        const validEndDates = [Date.parse(startDate)];
        for (let i = 1; i <= totalMonths; i++) {
            // startDate.setDate(startDate.getDate() + 15)
            startDate.setMonth(startDate.getMonth() + 1)
            let nextMonthDate = startDate.setDate(1)
            validEndDates.push(nextMonthDate);
        }
        console.log(validEndDates)
        return validEndDates;
    }

    const onAddPerks = (programId) => {
        history.push(`/programs/perk-programs/${programId}/add-perks`);
    };

    const AddNewProgramForm = <>
        <tr key="0" className="center aligned" style={{ backgroundColor: 'rgba(238, 241, 243, 1)' }}>
            <td><input type="text" className="ui input" value={newPerksProgramName} onChange={e => setNewPerksProgramName(e.target.value)} required /></td>
            <td></td>
            <td><DatePicker className="ui input" selected={newPerksProgramStartDate} minDate={monthlyStartDates[0]}
                            onChange={date => {setNewPerksProgramStartDate(date); console.info({date})}} includeDates={monthlyStartDates}/></td>
            <td><Checkbox checked={endDateEnabled} onChange={e => setEndDateEnabled(!endDateEnabled)}/></td>
            <td>{endDateEnabled && (
                // <DatePicker className="ui input" selected={newPerksProgramEndDate} minDate={currentDate} onChange={date => setNewPerksProgramEndDate(date)} includeDates={monthlyEndDates}/>)}</td>
                <DatePicker className="ui input" selected={newPerksProgramEndDate} minDate={monthlyEndDates[0]} onChange={date => {setNewPerksProgramEndDate(date); console.info({date})}} includeDates={monthlyEndDates}/>)}</td>
            <td>monthly</td>
            <td className="right aligned">
                {/* <button className="ui button center aligned" onClick={() => setShowNewPerksProgramInlineForm(false)}>Cancel</button> */}
                <button className="ui button center aligned" onClick={newProgramCancelHandler}>Cancel</button>
                <button className="ui button primary center aligned" onClick={addNewProgramHandler}
                    disabled={!newPerksProgramName.length || invalidDateRange}>Save
                </button>
            </td>
        </tr>
    </>;

    const activePrograms = (<>{showNewPerksProgramInlineForm && AddNewProgramForm}
        {perkPrograms.map(perkProgram => (perkProgram.active && <PerkProgram key={perkProgram.id} {...perkProgram}
            onEdit={editProgramHandler}
            onDelete={handleDelete}
            resetEditInProgress={handleResetEditInProgress}
            editInProgress={checkIfAlreadyEditing}
            onAddPerks={onAddPerks}
            onSelect={handlePerkProgramSelectionChange} perkProgram={perkProgram} />))}</>);

    const expiredPrograms = (perkPrograms.map(perkProgram => (!perkProgram.active && <PerkProgram key={perkProgram.id} {...perkProgram} />)));

    return (
        <div className="sub-page" id="perks-program-management" style={{ width: '90vw' }}>

            {appContext.loading && (<Dimmer active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>)}
            {/* {!addPerksClicked ?  */}
            <>
                {activeProgramsSection && (<div className="ui two column grid" style={{ width: '90vw' }}>
                    <div className="column">

                    </div>

                    <div className="column right aligned">
                        <button className={showNewPerksProgramInlineForm || currentlyEditingPerkProgramId !== '' ? 'ui button disabled' : 'ui button'}
                            onClick={e => setShowNewPerksProgramInlineForm(true)}><i className="plus alternate icon" />Add Program
                        </button>
                    </div>
                </div>)}

                <table className="ui table teams" style={{ backgroundColor: 'transparent' }}>
                    <thead style={{ backgroundColor: 'transparent' }}>
                        <tr className="center aligned" style={{ backgroundColor: 'transparent' }}>
                            <th style={{ backgroundColor: 'transparent' }}>Program Name</th>
                            <th width='15%' style={{ backgroundColor: 'transparent' }}>Teams</th>
                            <th style={{ backgroundColor: 'transparent' }}>Start Date <i className="calendar alternate icon" /></th>
                            {activeProgramsSection && <th style={{ backgroundColor: 'transparent' }}>End Date On</th>}
                            <th style={{ backgroundColor: 'transparent' }}>End Date <i className="calendar alternate icon" /></th>
                            <th style={{ backgroundColor: 'transparent' }}>Frequency</th>
                            {activeProgramsSection && (<th style={{ backgroundColor: 'transparent' }}></th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {activeProgramsSection && activePrograms}
                        {!activeProgramsSection && expiredPrograms}
                    </tbody>
                </table>

                {/* <footer>
                </footer> */}

                <Modal dimmer={dimmer} open={showSaveChangesModal}
                    size="mini" onClose={saveChangesModalCloseHandler}>
                    <Modal.Content><p>Save changes in this perk program?</p>
                    </Modal.Content>
                    <Modal.Actions className="center aligned">
                        <Button onClick={saveChangesModalCloseHandler}>Cancel</Button>
                        <Button className="primary" content="Save"
                            onClick={saveChangesModalCloseHandler} />
                    </Modal.Actions>
                </Modal>

                <Confirm className="confirm-modal" open={showConfirmDeleteModal}
                    content='Are you sure to delete this Perk Program?'
                    cancelButton='Cancel'
                    confirmButton="Delete"
                    onCancel={handleCancelDelete} onConfirm={handleConfirmDelete} />

                <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                    <Modal.Content><p>{infoModalText}</p></Modal.Content>
                    <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
                </Modal>
            </>
            {/* :   
                <Switch>
                    <Route path = "programs/perk-programs/add-perks"><AddPerksToProgramPage id={thisId} /></Route>
                </Switch>
                
            } */}
        </div>
    );
};
